// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080848/js/" + chunkId + "." + {"44":"851f9633","225":"449c45e8","481":"51ce1612","486":"5d2cfc3a","770":"ca8294f8"}[chunkId] + ".0.09156375515083703.chunk.js";
};